<template>
  <div>
    <v-btn fab color="primary" @click="$refs.inputCamera.click()">
      <v-icon>photo_camera</v-icon>
    </v-btn>
    <input
      v-show="false"
      ref="inputCamera"
      type="file"
      accept="image/*"
      capture="environment"
      @change="uploadFile()"
    >
  </div>
</template>

<script>
import { photoService } from "@/services/question";
import { webSocketService } from "@/services/question";

export default {
  name: "Camera",
  props: {
    questionId: String
  },
  methods: {
    uploadFile() {
      const file = this.$refs.inputCamera.files[0];
      const formData = new FormData();
      formData.append("file", file);
      photoService.savePhoto(formData).then(req => {
        this.photo = req.data.photoPath;
        webSocketService.send({"questionId": this.questionId, "photoUrl": req.data.photoPath });
      });
    }
  }
};
</script>
